import { defineProperty as _defineProperty } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { usePathContext } from '../../../context/PathContext.js';
import classNames from 'classnames';
import PlainText from '../../PlainText/index.js';
import { ListPathQuestionSchemaType } from '../../../generated/types.js';
import SuccessCheck from '../success-check.svg.js';
import styles from './styles.css.js';

var DefaultCard = function DefaultCard(_ref) {
  var _classNames, _classNames3;

  var icon = _ref.icon,
      choice = _ref.choice,
      disabled = _ref.disabled,
      question = _ref.question,
      isSelected = _ref.isSelected,
      onHandleChange = _ref.onHandleChange;
  var pathContext = usePathContext();
  var isSingleSelect = question.listSchemaType === ListPathQuestionSchemaType.SINGLE_SELECT_LIST;
  var buttonClasses = classNames(styles.common, (_classNames = {}, _defineProperty(_classNames, styles.placementDefault, pathContext.pathPlacement === 'default'), _defineProperty(_classNames, styles.selected, isSelected), _classNames));
  var IconComponent;

  if (typeof icon === 'string') {
    IconComponent = React.createElement("img", {
      src: icon,
      className: styles.icon
    });
  }

  if (typeof icon === 'function') {
    var Icon = icon;
    IconComponent = React.createElement(Icon, {
      className: styles.icon
    });
  }

  var headlineStyles = classNames(styles.headline, _defineProperty({}, styles.headlineWithIcon, !!IconComponent));
  var iconContainerStyles = classNames(styles.iconContainer, (_classNames3 = {}, _defineProperty(_classNames3, styles.placementDefault, pathContext.pathPlacement === 'default'), _defineProperty(_classNames3, styles.iconContainerNoBody, !choice.subText), _defineProperty(_classNames3, styles.iconContainerWithBody, !!choice.subText), _classNames3));
  return React.createElement("label", {
    className: styles.wrapper,
    htmlFor: choice.id
  }, React.createElement("input", {
    id: choice.id,
    name: isSingleSelect ? question.id : choice.id,
    type: isSingleSelect ? 'radio' : 'checkbox',
    className: styles.input,
    value: choice.id,
    disabled: disabled,
    checked: isSelected,
    onChange: function onChange(ev) {
      onHandleChange({
        choiceId: choice.id,
        isChecked: ev.target.checked
      });
    }
  }), React.createElement("div", {
    className: buttonClasses
  }, IconComponent && React.createElement("div", {
    className: iconContainerStyles
  }, IconComponent), isSelected && React.createElement(SuccessCheck, {
    className: styles.successCheck
  }), React.createElement("div", {
    className: styles.cardContent
  }, choice.text && React.createElement("div", {
    className: headlineStyles
  }, React.createElement(PlainText, {
    plainTextEntry: choice.text
  })), choice.subText && React.createElement("div", {
    className: classNames(styles.body, _defineProperty({}, styles.placementDefault, pathContext.pathPlacement === 'default'))
  }, React.createElement(PlainText, {
    plainTextEntry: choice.subText
  })))));
};

export default DefaultCard;
//# sourceMappingURL=index.js.map
